export enum WhatsAppCallingIconVisibility {
  NOT_SET = 'NOT_SET',
  DEFAULT = 'DEFAULT',
  DISABLE_ALL = 'DISABLE_ALL',
}
